import axios from "axios";
import store from "@/state/store";

async function loginCheckout() {
  return await axios.post(
    "https://checkout.ofiscom.net/Auth/Login",
    {
      domain: `${localStorage.getItem("currentUrl")}`,
      password: "Ofiscom2024*.!",
    },
    {}
  );
}
async function getPaymentList(params) {
  let queryParams = `https://checkout.ofiscom.net/Payments/GetAllByClientId?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}`;
  if (params.erpCustomerCode) {
    queryParams += `&erpCustomerCode=${params.erpCustomerCode}`;
  }
  if (params.erpSalesPersonCode) {
    queryParams += `&erpSalesPersonCode=${params.erpSalesPersonCode}`;
  }
  let config = {
    method: "get",
    url: queryParams,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: {},
  };
  return await axios.request(config);
}

async function getByPrefix(Prefix) {
  let config = {
    method: "get",
    url: `https://checkout.ofiscom.net/Banks/GetBinByPrefix?Prefix=${Prefix}`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: {},
  };
  return await axios.request(config);
}

async function payPayment(paymentData) {
  let config = {
    method: "post",
    url: `https://checkout.ofiscom.net/Payments/Pay`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: paymentData,
  };
  return await axios.request(config);
}

async function confirmPayment(paymentId) {
  let config = {
    method: "post",
    url: `https://checkout.ofiscom.net/Payments/Confirm/${paymentId}`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: {},
  };
  const result = await axios.request(config);
  return result;
}

async function generateReceipt(receiptId) {
  let config = {
    method: "post",
    url: `https://checkout.ofiscom.net/Payments/GenerateReceipt/${receiptId}`,
    headers: {
      Authorization: "Bearer " + store.state.virtualPayment.checkoutToken,
      "content-type": "application/json",
    },
    data: {},
  };
  const result = await axios.request(config);
  return result;
}

export {
  loginCheckout,
  getByPrefix,
  payPayment,
  confirmPayment,
  getPaymentList,
  generateReceipt,
};
